/**
 * Outline SVG icon module.
 */
import * as React from "react";
/**
 * Pencil (outline) SVG icon. Generated wrapper that forwards props to the root svg.
 *
 * @param {React.SVGProps<SVGSVGElement>} props SVG element props.
 * @returns {JSX.Element}
 */
const SvgPencil = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >

    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.333}
      d="m44.155 37.494 2.357 2.357m-1.357-3.357a1.667 1.667 0 1 1 2.357 2.357l-9.179 9.179H36v-2.381z"
    />
  </svg>
);
export default SvgPencil;
